<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vPWPAp/tc-custom/9781504098854.jpg?1729937558270" alt="This image is the cover for the book Diary of a Witchcraft Shop"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Diary of a Witchcraft Shop
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Experience a colorful year in the life of a novelist and her partner as they run a Glastonbury witchcraft supply shop in this charming memoir.</b><br/><br/> While some might know Glastonbury for its five-day music festival, the Somerset market town is also known as a center of pilgrimage and miracles. For over a thousand years, visitors have come to Glastonbury for Christ, the goddess, the god, angels, and fairies, as well as solutions and answers. It is also where novelist Liz Williams met Trevor Jones, the owner of a witchcraft shop. Their relationship began to flourish, and in 2005, Liz took the plunge and moved from Brighton to Glastonbury to live and work with Trevor. Her life would never be the same . . .<br/><br/> In <i>Diary of a Witchcraft Shop</i>, Liz and Trevor share anecdotes from the course of one year in their lives. Experience the eccentric day-to-day life of a small business in a tourist town, with staff troubles and quirky customers. Get a glimpse of the pagan world, its rituals, and its holidays. Travel with Liz and Trevor to the Houses of Parliament, Ireland, Brittany, and elsewhere. There are also plenty of surprises, too, like Shetland ponies and the TARDIS.<br/><br/> Full of humor as well as insightful observations from life’s light-hearted—and sometimes dark—moments, <i>Diary of a Witchcraft Shop</i> shows that sometimes life is stranger than fiction. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Trevor Jones, Liz Williams
      </h2>
      
      <p class="authorDescription body article">Liz Williams is a science fiction and fantasy writer living in Glastonbury, England, where she is codirector of a witchcraft supply business and where she and her partner Trevor ran the brick-and-mortar witchcraft shop described in their coauthored book for twenty years. The author of seventeen novels and over one hundred short stories, she has been published by Bantam Spectra and Night Shade Books in the US, and by Tor Macmillan in the UK. Liz teaches creative writing and has recently completed work on the <I>Compendium of the Occult</I> for Thames and Hudson, as well as a book on folklore for Reaktion Books. She also teaches magic.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6f4c274e